
import { Popover } from '@headlessui/react'
import propTypes from "prop-types"
import { Button } from '..'
import React from 'react';

export const NormalPopover = ({ children, content, className }) => {
    return (
        <Popover>
            {({ open, close }) => (
                <>
                    <Popover.Button as={'div'} className={"z-2"} onBlur={close}>
                        {children}
                    </Popover.Button>
                    {open && (
                        <Popover.Panel
                            static
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                            anchor="bottom"
                            className={className}>
                            {React.cloneElement(content, { open, close })}
                        </Popover.Panel>
                    )}
                </>
            )}
        </Popover>
    )
}


NormalPopover.propTypes = {
    children: propTypes.element,
    content: propTypes.element,
    open: propTypes.bool,
    className: propTypes.string
}

NormalPopover.defaultProps = {
    children: <Button text="Popover" />,
    content: <>This is default popover</>,
    open: false,
    className: 'absolute  z-[999] top-0 left-0 right-0 bottom-0 '

}